import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
    errorPrefix: string = "errors.";
    constructor(
        private snackbar: MatSnackBar,
        private router: Router,
        private zone: NgZone,
        private translate: TranslateService
    ) {
        super();
    }

    handleError(error: any) {
        super.handleError(error);
        console.error(error.statusCode)

        // Check if it's an error from an HTTP response
        if (!(error instanceof HttpErrorResponse)) {
            if (error && error.status == 401) {
                this.router.navigate(["neautorizovanPristup"]);

            }
        }
        this.zone.run(() => {
            if (error?.name == 'InvalidTokenError') {
                this.snackbar.open(this.translate.instant(this.errorPrefix + "isteklaSesija"), null, { duration: 5000, panelClass: ["errorSnack"] });
                console.error(error?.message);
                console.error(error?.statusCode);
                this.router.navigate(['/session/signin']);
            }
        }
        );

        console.error('Error from global error handler', error);
    }
}
